import React, { memo, useContext } from "react";
import { Routes, Route } from "react-router-dom";
import environment from "@environment";
import { MenuArea } from "core/constants";
import { AppContext } from "core/context";
import { useUpdateMenu } from "core/hooks";
import PayAtStore from "core/stores/pay-at.store";
import PaymentStore from "core/stores/payment.store";
import PaymentFailure from "self-service/payments/failure";
import MahPayment from "self-service/payments/mah/payment";
import Payment from "self-service/payments/payment";
import PaymentResult from "self-service/payments/result";
import PaymentSuccess from "self-service/payments/success";

const payAtStore = new PayAtStore();
const paymentStore = new PaymentStore();

const PaymentLayout = () => {
    const appContext = useContext(AppContext);
    useUpdateMenu(MenuArea.pay);

    return (
        <Routes>
            <Route
                path="mah"
                element={environment.production
                    ? null
                    : <MahPayment store={paymentStore} />}
            />

            <Route path="failure" element={<PaymentFailure />} />
            <Route path="success" element={<PaymentSuccess />} />
            <Route path="result" element={<PaymentResult />} />
            <Route path="result/success" element={<PaymentResult />} />
            <Route path="result/failure" element={<PaymentResult />} />
            <Route path="*" element={appContext.user?.isSouthAfricanCustomer
                ? <Payment store={payAtStore} />
                : <MahPayment store={paymentStore} />} />
        </Routes>
    );
}

export default memo(PaymentLayout);
